import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { Fade, Flip } from 'react-awesome-reveal';
import { QRCodeCanvas } from 'qrcode.react';


const AndroidApp = () => {
    const url = process.env.REACT_APP_ANDROID_APP_URL;
    const directApkUrl = process.env.REACT_APP_DIRECT_APK;
    // const navigate = useNavigate();

    // const checkURL = () => {
    //     if (url) {
    //         window.location.href = url;
    //         setTimeout(() => {
    //             window.close();
    //           }, 2000)
    //     } else {
    //         navigate('/')
    //     }
    // }

    // useEffect(() => {
    //     checkURL();
    //     // eslint-disable-next-line
    // }, [])

    return (
        <>

            <div className="relative min-h-screen flex items-center justify-center bg-cover bg-no-repeat" style={{ backgroundImage: "url('/assets/images/partnership-bg.png')" }}>

                {/* <div className="absolute top-6 left-1/2 transform -translate-x-1/2 z-20">
                    <img
                        src="/assets/images/w11-black.png"
                        alt="World11 Logo"
                        className="w-20 h-20 object-contain sm:w-24 sm:h-24 md:w-28 md:h-28"
                    />
                </div> */}

                <div className="absolute top-6 left-6 z-20">
                    <img
                        src="/assets/images/w11-black.png"
                        alt="Corner Logo"
                        className="w-16 h-16 object-contain md:w-20 md:h-20"
                    />
                </div>

                <div className="relative z-10 max-w-4xl w-full px-4 mt-10 text-center text-black">
                    <Fade direction="up">
                        <h1 className="lg:text-4xl text-3xl font-bold mb-6">
                            Download World 11 Fantasy App
                        </h1>
                    </Fade>

                    <Fade direction="up" delay={200}>
                        <p className="text-lg mb-10">
                            Introducing World 11 - the next level in fantasy sports! Download our app now to create your dream team and join millions of players in thrilling competitions for amazing rewards. Don’t miss out on the excitement, join World 11 today!
                        </p>
                    </Fade>

                    <Fade direction="up" delay={400}>
                        <div className="flex flex-col sm:flex-row justify-center items-center gap-6">
                            <a
                                href={url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-black text-white text-sm font-semibold px-6 py-2 rounded-2xl flex items-center hover:scale-95 transition-transform duration-300 shadow-lg"
                            >
                                <i className="fa-brands fa-google-play text-2xl mr-3"></i>
                                Play Store
                            </a>

                            <a
                                href={directApkUrl}
                                rel="noopener noreferrer"
                                className="bg-black text-white text-sm font-semibold px-6 py-2 rounded-2xl flex items-center hover:scale-95 transition-transform duration-300 shadow-lg"
                            >
                                <i className="fa-solid fa-download text-2xl mr-3"></i>
                                Direct APK
                            </a>
                        </div>
                    </Fade>
                </div>
            </div>

        </>
    )
}

export default AndroidApp